var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAyakkabDnyas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 13,
    viewBox: "0 0 187 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.70981 8.21151L5.18442 5.47436L6.63963 8.21151H3.70981ZM4.64502 3.05859L0 11.7539H1.8161L2.95698 9.61882H7.41574L8.55664 11.7539H10.3921L5.70442 3.05859H4.64502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3062 5.96934L13.4579 3.05859H11.246L15.4719 7.37669V11.7539H17.1405V7.35822L21.3898 3.05859H19.1118L16.3062 5.96934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9652 8.21151L27.4398 5.47436L28.895 8.21151H25.9652ZM26.8965 3.05859L22.2515 11.7539H24.0637L25.2046 9.61882H29.6633L30.8042 11.7539H32.6397L27.9559 3.05859H26.8965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9367 3.08057H42.6278L38.1729 6.63404V3.08057H36.481V11.7537H38.1729V8.51419L39.8066 7.19181L43.4311 11.7537H45.3713L41.0212 6.23511L44.9367 3.08057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7501 3.08057H55.4413L50.9825 6.63404V3.08057H49.2905V11.7537H50.9825V8.51419L52.62 7.19181L56.2445 11.7537H58.1809L53.8308 6.23511L57.7501 3.08057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.899 8.21151L66.3736 5.47436L67.8288 8.21151H64.899ZM65.8342 3.05859L61.1892 11.7539H63.0053L64.1461 9.61882H68.6049L69.7458 11.7539H71.5813L66.8936 3.05859H65.8342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1063 7.79023H81.4096C82.3025 7.79023 82.7756 8.21131 82.7756 9.00918C82.7756 9.80705 82.2905 10.2466 81.4096 10.2466H77.1063V7.79023ZM80.9672 6.26096H77.1063V4.58765H80.9439C82.0036 4.58765 82.1395 5.03461 82.1395 5.42246C82.1395 5.78446 82.0194 6.26096 80.9672 6.26096ZM83.1557 6.84459C83.637 6.47891 83.8736 5.97285 83.8736 5.30426C83.8736 3.83041 82.9041 3.08057 80.9868 3.08057H75.4143V11.7537H81.2624C83.2961 11.7537 84.5067 10.7564 84.5067 9.08676C84.5067 8.15589 84.0524 7.40236 83.1557 6.84459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2012 3.04004H89.4896V11.776H91.2012V3.04004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.209 7.41732C114.209 9.18669 113.01 10.2468 111.004 10.2468H108.606V4.56937H111.004C112.921 4.56937 114.209 5.71447 114.209 7.41732ZM110.985 3.05859H106.914V11.7539H110.985C113.996 11.7539 115.944 10.0585 115.944 7.43579C115.94 4.82055 113.949 3.05859 110.985 3.05859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.719 2.07204C127.329 2.07204 127.81 1.61769 127.81 1.03407C127.81 0.4726 127.313 -0.00390625 126.719 -0.00390625C126.13 -0.00390625 125.652 0.461518 125.652 1.03407C125.652 1.61769 126.122 2.07204 126.719 2.07204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.421 2.07204C124.019 2.07204 124.488 1.61769 124.488 1.03407C124.488 0.461518 124.01 -0.00390625 123.421 -0.00390625C122.83 -0.00390625 122.33 0.4726 122.33 1.03407C122.334 1.61769 122.811 2.07204 123.421 2.07204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.894 8.60657C127.894 10.1358 127.34 10.5089 125.07 10.5089C122.8 10.5089 122.248 10.1358 122.248 8.60657V3.08057H120.556V8.9464C120.556 11.1257 121.856 12.016 125.05 12.016C128.229 12.016 129.586 11.0962 129.586 8.9464V3.08057H127.894V8.60657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.241 8.71754L135.866 3.05859H134.919V11.7539H136.587V6.1171L141.962 11.7539H142.909V3.05859H141.241V8.71754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.799 5.96934L148.951 3.05859H146.743L150.965 7.37669V11.7539H152.633V7.35822L156.882 3.05859H154.605L151.799 5.96934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.458 8.21151L162.933 5.47436L164.388 8.21151H161.458ZM162.39 3.05859L157.745 11.7539H159.561L160.701 9.61882H165.16L166.301 11.7539H168.137L163.453 3.05859H162.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.053 6.26104C174.163 6.26104 173.461 6.02464 173.461 5.38561C173.461 4.74287 174.272 4.32917 175.525 4.32917C176.65 4.32917 177.927 4.72441 179.033 5.41146L179.169 5.49642L180.034 4.15186L179.902 4.07429C178.552 3.25795 177.085 2.84424 175.544 2.84424C173.239 2.84424 171.749 3.84527 171.749 5.3893C171.749 7.46893 173.725 7.67947 176.111 7.73489C177.931 7.79399 178.707 8.18181 178.707 9.0351C178.707 9.92166 177.718 10.5164 176.243 10.5164C174.955 10.5164 173.48 10.0657 172.292 9.31583L172.153 9.22721L171.315 10.5976L171.443 10.6752C172.89 11.5469 174.648 12.0271 176.391 12.0271C178.789 12.0271 180.461 10.8303 180.461 9.12004C180.461 7.21775 178.975 6.26104 176.053 6.26104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 3.04004H185.289V11.776H187V3.04004Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 12.0161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyakkabDnyas);
export default __webpack_public_path__ + "static/media/AyakkabıDünyası.856591892e73de4235a5de6e60580a46.svg";
export { ForwardRef as ReactComponent };